// import { useState, useEffect } from "react";
// import "./FAQsPageElementsCss/FAQsMainSection.css";
// import AnimatedText from "../../AnimatedText";
// import { getFaqCategory } from "../../api/api";
// import { logDOM } from "@testing-library/dom";
// import { getFaqdetails } from "../../api/api";

// export default function FAQsMainSection() {
//   const [activeTab, setActiveTab] = useState("General Queries");
//   const [openIndex, setOpenIndex] = useState(null);
//   const [faqCategory, setFaqCategory] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [message, setMessage] = useState("");
//   const [faqData, setFaqDetails] = useState([]);

//   //
//   //  calling api  getFaqCategory
//   useEffect(() => {
//     fetchFaqCategoryData();
//   }, []);

//   const fetchFaqCategoryData = async () => {
//     const payload = {};
//     try {
//       setLoading(true);
//       const res = await getFaqCategory(payload);
//       if (res?.data?.message === "success") {
//         const apiData = res?.data?.data || [];

//         if (apiData.length > 0) {
//           //fetch data in faqcategory
//           setActiveTab(apiData[0].faqCategoryId); // set default active tab when enter the page
//           setFaqCategory(apiData);
//           setMessage(""); // clear message when data found
//         } else {
//           // set empty array when data not found
//           setFaqCategory([]);
//           setMessage("No data found"); // set message when data not found
//         }
//       } else {
//         setFaqCategory([]);
//         setMessage("Problem on API");
//       }

//       console.log("res.data===>", res?.data);
//     } catch (error) {
//       console.error("Error fetching  faq data :", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   console.log("faqCategoryData=====>kkkkkk", faqCategory);

//   //call api getFaqdetails

//   // when changes active tab then trigger the function and fire the api
//   useEffect(() => {
//     if (activeTab) {
//       fetchGetFaqDetails(activeTab);
//     }
//   }, [activeTab]);

//   const fetchGetFaqDetails = async (categoryId) => {
//     const payload = { faqCategoryId: categoryId };

//     try {
//       setLoading(true);
//       const res = await getFaqdetails(payload);
//       if (res?.data?.message === "success") {
//         const apiData = res?.data?.data || [];

//         if (apiData.length > 0) {
//           //fetch data in getFaqdetails
//           setFaqDetails(apiData);
//           setMessage(""); // clear message when data found
//         } else {
//           // set empty array when data not found
//           setFaqDetails([]);
//           setMessage("No data found"); // set message when data not found
//         }
//       } else {
//         setFaqDetails([]);
//         setMessage("Problem on API");
//       }

//       console.log("res.data===>", res?.data);
//     } catch (error) {
//       console.error("Error fetching  faq data :", error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   const categories = [...faqCategory];
//   console.log("categoris==>", categories);

//   const toggleFAQ = (index) => {
//     setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
//   };

//   return (
//     <div className="faqMainContainer">
//       {/*</div><div className="ourPackageUpperSection">
//         <AnimatedText
//           tag="h2"
//           type="words"
//           y={30}
//           className="rb-title ourpackageTitle"
//         >
//           </AnimatedText>

//        { /*  FAQs*}
//         </AnimatedText>
//         <div className="textParaSection">
//           <p className="paraText faqPara">
//            RB Diagnostic offers a comprehensive range of health check-up
//             packages tailored for every stage of life.
//             <br />
//             Each package is designed by experts to provide accurate insights and
//             support preventive healthcare, ensuring timely diagnosis and better
//             health outcomes.
//           </p>
//         </div>
//       */}

//       {/* Desktop Buttons */}

//       <div className="midNavButtons desktop-only">
//         {faqCategory.map((category) => (
//           <button
//             key={category.faqHeader}
//             className={`navBtn ${
//               activeTab === category.faqHeader ? "active" : ""
//             }`}
//             onClick={() => {
//               // set active tab
//               setActiveTab(category.faqHeader);
//               // or category.faqHeader if you want text
//               setOpenIndex(null);
//             }}
//           >
//             {category.faqHeader}
//           </button>
//         ))}
//       </div>

//       {/* mobile Buttons */}

//       <div className="mobileDropdownContainer mobile-only">
//         <select
//           className="faqDropdown"
//           value={activeTab}
//           onChange={(e) => {
//             setActiveTab(e.target.value);
//             setOpenIndex(null);
//           }}
//         >
//           {categories.map((category) => (
//             <option key={category.faqCategoryId} value={category.faqCategoryId}>
//               {category.faqHeader}
//             </option>
//           ))}
//         </select>
//       </div>

//       <h3 className="faqHeading">Frequently Asked Question</h3>

//       <div
//         className={`faqGrid ${faqData?.length === 1 ? "singleItemCenter" : ""}`}
//       >
//         {/* Column 1 (even indices) */}
//         <div className="faqColumn">
//           {faqData
//             ?.filter((_, i) => i % 2 === 0)
//             .map((faq, index) => {
//               const actualIndex = index * 2;
//               return (
//                 <div
//                   className={`faqItem ${
//                     openIndex === actualIndex ? "open" : ""
//                   }`}
//                   key={faq.FaqId}
//                 >
//                   <div
//                     className="faqQuestion"
//                     onClick={() => toggleFAQ(actualIndex)}
//                   >
//                     <span>{faq.FaqName}</span>
//                     <button className="toggleIcon">
//                       {openIndex === actualIndex ? "−" : "+"}
//                     </button>
//                   </div>
//                   {openIndex === actualIndex && (
//                     <div
//                       className="faqAnswer"
//                       dangerouslySetInnerHTML={{ __html: faq.FaqDesc }}
//                     />
//                   )}
//                 </div>
//               );
//             })}
//           </div>

//         {/* Column 2 (odd indices) */}
//         <div className="faqColumn">
//           {faqData
//             ?.filter((_, i) => i % 2 !== 0)
//             .map((faq, index) => {
//               const actualIndex = index * 2 + 1;
//               return (
//                 <div
//                   className={`faqItem ${
//                     openIndex === actualIndex ? "open" : ""
//                   }`}
//                   key={faq.FaqId}
//                 >
//                   <div
//                     className="faqQuestion"
//                     onClick={() => toggleFAQ(actualIndex)}
//                   >
//                     <span>{faq.FaqName}</span>
//                     <button className="toggleIcon">
//                       {openIndex === actualIndex ? "−" : "+"}
//                     </button>
//                   </div>
//                   {openIndex === actualIndex && (
//                     <div
//                       className="faqAnswerWrapper"
//                       dangerouslySetInnerHTML={{ __html: faq.FaqDesc }}
//                     />
//                   )}
//                 </div>
//               );
//             })}
//         </div>
//       </div>
//     </div>
//   );
// }

// import { useState, useEffect } from "react";
// import "./FAQsPageElementsCss/FAQsMainSection.css";
// import AnimatedText from "../../AnimatedText";
// import { getFaqCategory, getFaqdetails } from "../../api/api";

// export default function FAQsMainSection() {
//   const [activeTab, setActiveTab] = useState("General Queries");
//   const [openIndex, setOpenIndex] = useState(null);
//   const [faqCategory, setFaqCategory] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [message, setMessage] = useState("");
//   const [faqData, setFaqDetails] = useState([]);

//   // helper: remove existing "1. " / "2. " from API text
//   const formatQuestionText = (text = "") => {
//     return text.replace(/^\s*\d+\.\s*/, ""); // strips "1. " at the start
//   };

//   useEffect(() => {
//     fetchFaqCategoryData();
//   }, []);

//   const fetchFaqCategoryData = async () => {
//     try {
//       setLoading(true);
//       const res = await getFaqCategory({});
//       if (res?.data?.message === "success") {
//         const apiData = res?.data?.data || [];
//         if (apiData.length > 0) {
//           setActiveTab(apiData[0].faqCategoryId);
//           setFaqCategory(apiData);
//           setMessage("");
//         } else {
//           setFaqCategory([]);
//           setMessage("No data found");
//         }
//       } else {
//         setFaqCategory([]);
//         setMessage("Problem on API");
//       }
//     } catch (error) {
//       console.error("Error fetching faq category:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (activeTab) {
//       fetchGetFaqDetails(activeTab);
//     }
//   }, [activeTab]);

//   const fetchGetFaqDetails = async (categoryId) => {
//     try {
//       setLoading(true);
//       const res = await getFaqdetails({ faqCategoryId: categoryId });
//       if (res?.data?.message === "success") {
//         const apiData = res?.data?.data || [];
//         if (apiData.length > 0) {
//           setFaqDetails(apiData);
//           setMessage("");
//         } else {
//           setFaqDetails([]);
//           setMessage("No data found");
//         }
//       } else {
//         setFaqDetails([]);
//         setMessage("Problem on API");
//       }
//     } catch (error) {
//       console.error("Error fetching faq details:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const toggleFAQ = (index) => {
//     setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
//   };

//   return (
//     <div className="faqMainContainer">
//       {/* Desktop tabs */}
//       <div className="midNavButtons desktop-only">
//         {faqCategory.map((category) => (
//           <button
//             key={category.faqCategoryId}
//             className={`navBtn ${
//               activeTab === category.faqCategoryId ? "active" : ""
//             }`}
//             onClick={() => {
//               setActiveTab(category.faqCategoryId);
//               setOpenIndex(null);
//             }}
//           >
//             {category.faqHeader}
//           </button>
//         ))}
//       </div>

//       {/* Mobile dropdown */}
//       <div className="mobileDropdownContainer mobile-only">
//         <select
//           className="faqDropdown"
//           value={activeTab}
//           onChange={(e) => {
//             setActiveTab(e.target.value);
//             setOpenIndex(null);
//           }}
//         >
//           {faqCategory.map((category) => (
//             <option key={category.faqCategoryId} value={category.faqCategoryId}>
//               {category.faqHeader}
//             </option>
//           ))}
//         </select>
//       </div>

//       <h3 className="faqHeading">Frequently Asked Questions</h3>

//       <div className="faqGrid">
//         {/* Column 1 (even indices) */}
//         <div className="faqColumn">
//           {faqData
//             ?.filter((_, i) => i % 2 === 0)
//             .map((faq, index) => {
//               const actualIndex = index * 2; // 0,2,4,6...
//               return (
//                 <div
//                   className={`faqItem ${
//                     openIndex === actualIndex ? "open" : ""
//                   }`}
//                   key={faq.FaqId}
//                 >
//                   <div
//                     className="faqQuestion"
//                     onClick={() => toggleFAQ(actualIndex)}
//                   >
//                     <span>
//                       {actualIndex + 1}. {formatQuestionText(faq.FaqName)}
//                     </span>
//                     <button className="toggleIcon">
//                       {openIndex === actualIndex ? "−" : "+"}
//                     </button>
//                   </div>
//                   {openIndex === actualIndex && (
//                     <div
//                       className="faqAnswerWrapper"
//                       dangerouslySetInnerHTML={{ __html: faq.FaqDesc }}
//                     />
//                   )}
//                 </div>
//               );
//             })}
//         </div>

//         {/* Column 2 (odd indices) */}
//         <div className="faqColumn">
//           {faqData
//             ?.filter((_, i) => i % 2 !== 0)
//             .map((faq, index) => {
//               const actualIndex = index * 2 + 1; // 1,3,5,7...
//               return (
//                 <div
//                   className={`faqItem ${
//                     openIndex === actualIndex ? "open" : ""
//                   }`}
//                   key={faq.FaqId}
//                 >
//                   <div
//                     className="faqQuestion"
//                     onClick={() => toggleFAQ(actualIndex)}
//                   >
//                     <span>
//                       {actualIndex + 1}. {formatQuestionText(faq.FaqName)}
//                     </span>
//                     <button className="toggleIcon">
//                       {openIndex === actualIndex ? "−" : "+"}
//                     </button>
//                   </div>
//                   {openIndex === actualIndex && (
//                     <div
//                       className="faqAnswerWrapper"
//                       dangerouslySetInnerHTML={{ __html: faq.FaqDesc }}
//                     />
//                   )}
//                 </div>
//               );
//             })}
//         </div>
//       </div>
//     </div>
//   );
// }

import { useState, useEffect } from "react";
import "./FAQsPageElementsCss/FAQsMainSection.css";
import AnimatedText from "../../AnimatedText";
import { getFaqCategory, getFaqdetails } from "../../api/api";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";


export default function FAQsMainSection() {
  const [activeTab, setActiveTab] = useState(null);
  const [openIndex, setOpenIndex] = useState(null);
  const [faqCategory, setFaqCategory] = useState([]);
  const [faqData, setFaqDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  const location = useLocation();
  const navigate = useNavigate();


  // Slugs for URL
  const categorySlugMap = {
    "General Queries": "general",
    "Home Collection": "home-collection",
    "Diagnostic Test Information": "diagnostic",
    "Payments": "payments",
    "Reports": "reports",
    "Contact and Support": "contact",
  };

  // Fetch categories
  useEffect(() => {
    fetchFaqCategoryData();
  }, []);

  const fetchFaqCategoryData = async () => {
    try {
      setLoading(true);
      const res = await getFaqCategory({});

      if (res?.data?.message === "success") {
        const apiData = res?.data?.data || [];

        if (!apiData.length) {
          setFaqCategory([]);
          setMessage("No data found");
          return;
        }

        setFaqCategory(apiData);

        // 🔥 URL hash logic
        const hash = window.location.hash.replace("#", "");

        let selectedCategory = apiData[0]; // default

        if (hash) {
          const matched = apiData.find(
            (cat) => categorySlugMap[cat.faqHeader] === hash
          );
          if (matched) selectedCategory = matched;
        }

        setActiveTab(selectedCategory.faqCategoryId);
        setMessage("");
      } else {
        setMessage("Problem on API");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // Fetch FAQ details when tab changes
  useEffect(() => {
    if (activeTab) {
      fetchGetFaqDetails(activeTab);
    }
  }, [activeTab]);

  const fetchGetFaqDetails = async (categoryId) => {
    try {
      setLoading(true);
      const res = await getFaqdetails({ faqCategoryId: categoryId });

      if (res?.data?.message === "success") {
        const apiData = res?.data?.data || [];
        setFaqDetails(apiData);
        setMessage(apiData.length ? "" : "No data found");
      } else {
        setMessage("Problem on API");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const toggleFAQ = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  const formatQuestionText = (text = "") =>
    text.replace(/^\s*\d+\.\s*/, "");

  return (
    <>
      {loading && (
        <div className="page-loader">
          <div className="loader-ring"></div>
        </div>
      )}

 <div style={{margin:'5px 10px'}} >
  <button className="faqBackBtn" onClick={() => navigate(-1)}>
    ← Back
  </button>
</div>

      <div className="faqMainContainer">

        {/* Desktop Tabs */}
        <div className="midNavButtons desktop-only">
          {faqCategory.map((cat) => (
            <button
              key={cat.faqCategoryId}
              className={`navBtn ${
                activeTab === cat.faqCategoryId ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab(cat.faqCategoryId);
                setOpenIndex(null);
              }}
            >
              {cat.faqHeader}
            </button>
          ))}
        </div>

        {/* Mobile Dropdown */}
        <div className="mobileDropdownContainer mobile-only">
          <select
            className="faqDropdown"
            value={activeTab || ""}
            onChange={(e) => {
              setActiveTab(e.target.value);
              setOpenIndex(null);
            }}
          >
            {faqCategory.map((cat) => (
              <option key={cat.faqCategoryId} value={cat.faqCategoryId}>
                {cat.faqHeader}
              </option>
            ))}
          </select>
        </div>

        {/* FAQ Grid */}
        <div className={`faqGrid ${faqData.length === 1 ? "singleItemCenter" : ""}`}>
          {/* Column 1 */}
          <div className="faqColumn">
            {faqData.filter((_, i) => i % 2 === 0).map((faq, index) => {
              const actualIndex = index * 2;
              return (
                <div key={faq.FaqId} className={`faqItem ${openIndex === actualIndex ? "open" : ""}`}>
                  <div className="faqQuestion" onClick={() => toggleFAQ(actualIndex)}>
                    <span>{actualIndex + 1}. {formatQuestionText(faq.FaqName)}</span>
                    <button>{openIndex === actualIndex ? "−" : "+"}</button>
                  </div>
                  {openIndex === actualIndex && (
                    <div className="faqAnswer" dangerouslySetInnerHTML={{ __html: faq.FaqDesc }} />
                  )}
                </div>
              );
            })}
          </div>

          {/* Column 2 */}
          <div className="faqColumn">
            {faqData.filter((_, i) => i % 2 !== 0).map((faq, index) => {
              const actualIndex = index * 2 + 1;
              return (
                <div key={faq.FaqId} className={`faqItem ${openIndex === actualIndex ? "open" : ""}`}>
                  <div className="faqQuestion" onClick={() => toggleFAQ(actualIndex)}>
                    <span>{actualIndex + 1}. {formatQuestionText(faq.FaqName)}</span>
                    <button>{openIndex === actualIndex ? "−" : "+"}</button>
                  </div>
                  {openIndex === actualIndex && (
                    <div className="faqAnswer" dangerouslySetInnerHTML={{ __html: faq.FaqDesc }} />
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>

     

    </>
  );
}